<section class="login-label">
  <div class="container marging-bot0">
    <div class="row">
      <div class="col-sm-12 padding0" *ngIf="isDataAvailable">
        <h1>{{ headerData.mainLinks[0].heading }}</h1>
      </div>
    </div>
  </div>
</section>
<div class="gradient-bg" *ngIf="artisanEdgeLabel">
  <div class="container artisan-text">
    {{ artisanEdgeLabel }}
    <span>&nbsp;</span>
  </div>
</div>
<ngbd-carousel *ngIf="bannerData" [bannerData]="bannerData"></ngbd-carousel>
<section class="body-section" *ngIf="isDataAvailable">
  <div class="container max-width-1180">
    <div class="row d-flex">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 top-box-right">
        <span>
          <badge
            [entity]="badge"
            (badgeSelectEvent)="badgeSelected($event)"
          ></badge>
        </span>
        <div
          class="row mt-4 custom-position"
          (clickOutside)="onClickedOutside($event)"
        >
          <div
            class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
            [ngClass]="{ 'active-class': isShow }"
          >
            <button
              type="button"
              id="create-new-claim-btn"
              class="btn btn-primary w-100"
              (click)="showNewQuote()"
            >
              {{ (dashboardSitecoreData?.buttons)[0]?.keyText }}
            </button>
          </div>
          <div
            class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
            [ngClass]="{ 'active-class': isShowProductInfo }"
          >
            <button
              type="button"
              id="create-new-claim-btn"
              class="btn btn-primary w-100"
              (click)="showProductInfo()"
            >
              {{ (dashboardSitecoreData?.buttons)[1]?.keyText }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
        <ac-tabs></ac-tabs>

        <div class="row mt-4 custom-position">
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <button
              type="button"
              id="create-new-claim-btn"
              class="btn btn-primary w-100"
              (click)="agencyLossRun()"
            >
              Agency Loss Run
            </button>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <button
              type="button"
              id="create-new-claim-btn"
              class="btn btn-primary w-100"
              (click)="boundPolicyReport()"
            >
              Bound Policy Report
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="isShow" class="popup-bg"></div>
      <div class="quote-menu col-sm-12 col-lg-12" *ngIf="isShow">
        <div class="row neg-margin8">
          <div class="col-sm-12 col-lg-12 gray-bg" *ngIf="isDataAvailable">
            <span class="cross-icon" (click)="onClickedOutside($event)">×</span>
            <h2>{{ headerData.headerDropdown[0].heading }}</h2>
            <div class="row">
              <div
                class="col-xs-12 col-sm-6 col-md-6 col-lg-3 mt-3"
                *ngFor="let item of productList"
                (click)="
                  newQuote(item.Name, item.PolicyTypeId, item.SubCompanyCode);
                  onClickedOutside($event)
                "
              >
                <img src="{{ item.imageSrc }}" />
                <a href="javascript:void(0)">
                  {{ item?.Name }}
                  <span class="border-bottom"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isShowProductInfo" class="popup-bg"></div>
      <div class="product-menu col-sm-12 col-lg-12" *ngIf="isShowProductInfo">
        <div class="row neg-margin8">
          <div class="col-sm-12 col-lg-12 gray-bg" *ngIf="isDataAvailable">
            <span class="cross-icon" (click)="onClickedOutside($event)">×</span>
            <h2>{{ headerData.headerDropdown[1].heading }}</h2>
            <div class="row">
              <div
                class="col-sm-4 col-lg-4 mt-2"
                (click)="onClickedOutside($event)"
                *ngFor="let item of headerData.headerDropdown[1].displayItems"
              >
                <a [href]="item.navigation.Url+'?v=1'" target="_blank">{{
                  item.keyText
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="select-risk-section">
      <div class="row mt-1">
        <div class="col-sm-12">
          <nav id="nav"></nav>
          <!-- <div *ngIf="gridloading">
            <span class="animated-background d-block"></span>
            <span class="animated-background d-block"></span>
            <span class="animated-background d-block"></span>
            <span class="animated-background d-block"></span>
            <span class="animated-background d-block"></span>
          </div> -->      
          <div class="risk-info-box">
            <div *ngFor="let item of accordionGridData; let i = index">
              <!-- <span *ngIf="gridRefresh && !gridloading"> -->
              <hcc-accordion
                (linkClickedEvent)="accordianEvent($event)"
                [accordionData]="item"
                [gridTemplate]="true"
                (emitSelectedValue)="gridRowEvent($event)" 
                (onData)="handleData($event)"                
              >
              </hcc-accordion>              
              <!-- </span> -->
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</section>
